import { autoinject, transient } from "aurelia-framework";
import { OnboardingAdminService } from "../../../../../../services/onboarding/onboarding-admin.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { QueriesClientService } from "../../../../../../services/queries/queries-client.services";
import { AllEntityTypeConfigurationConstants } from "../../../../../../models/basics/basics.models";
import { GenesisRouterConstants } from "../../../../../../configuration/router.constants";
import { NotificationClientService, NotificationType } from "../../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";

@autoinject()
@transient()
export class CreateDyamicOnboardingPluginDialog {

    public displayName: string;
    public displayODataName: string;
    public model: { reloadData: () => void };

    constructor(private onboardingAdminService: OnboardingAdminService,
        private dialogClientService: DialogClientService,
        private notificationClientService: NotificationClientService,
        private i18N: I18N,
        private queriesClientService: QueriesClientService) { }

    activate(model: { reloadData: () => void }) {
        this.model = model;
    }

    save() {
        return new Promise<void>((resolve, reject) => {
            this.onboardingAdminService.createDynamicOnboardingPlugin({
                displayName: this.displayName,
                displayODataName: this.displayODataName,
            }).then(response => {
                if (response.existingPluginWithSameDisplayName) {
                    this.notificationClientService.show(this.i18N.tr('validation-error-text') + "!", "There is already a plugin with same Display Name", NotificationType.Error);
                    reject();
                    return;
                } else if (response.existingPluginWithSameODataDisplayName) {
                    this.notificationClientService.show(this.i18N.tr('validation-error-text') + "!", "There is already a plugin with same OData Display Name", NotificationType.Error);
                    reject();
                    return;
                } else if (response.existingEntityWithSameName) {
                    this.notificationClientService.show(this.i18N.tr('validation-error-text') + "!", "There is already an entity in the system with same name", NotificationType.Error);
                    reject();
                    return;
                }
                this.dialogClientService.hide();
                this.queriesClientService.clearCache();

                this.onboardingAdminService.getODataModels().then(x => {
                    if (x.entityConfigs) {
                        x.entityConfigs.forEach(config => {
                            if (!AllEntityTypeConfigurationConstants.some(z => z.uri == config.uri)) {
                                AllEntityTypeConfigurationConstants.push({
                                    claims: [],
                                    navbar: "onboardingrequests",
                                    editRoute: GenesisRouterConstants.RouteNames.OnboardingRequest,
                                    uri: config.uri,
                                    title: config.title,
                                    entityType: config.entityTypeId,
                                    typeSingular: config.typeSingular,
                                    isVisible: true
                                });
                            }
                        });
                    }
                });
                if (this.model.reloadData) {
                    this.model.reloadData();
                }
                resolve();
            }).catch(() => {
                reject();
            });
        });
    }

    cancel() {
        this.dialogClientService.hide();
    }
}
